<template>
  <b-card
    :id="`connector-${index + 1}`"
    class="card-table"
    no-body
  >
    <div
      class="logo__wrapper"
      @click="onConnectorClick"
    >
      <b-img :src="`/assets/connectorImages/${image}`" />
    </div>

    <b-card-title>
      {{ JSON.parse(item.credentials).Tenant }}
    </b-card-title>
    <div class="actions__wrapper">
      <b-button
        :id="`connector-${index + 1}-edit`"
        variant="outline-primary"
        size="sm"
        @click="onEditClick"
      >
        <font-awesome-icon :icon="['fas','pencil-alt']" />
        Edit
      </b-button>
      <b-button
        :id="`connector-${index + 1}-delete`"
        variant="outline-danger"
        size="sm"
        @click="onDeleteClick"
      >
        <font-awesome-icon :icon="['fas','trash']" />
        Delete
      </b-button>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'ConnectorCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: Number,
  },
  computed: {
    isEfront() {
      return this.item.vendor === 'Efront';
    },
    image() {
      if (this.item.vendor === 'PitchBook') {
        return 'pitchbook-vector-logo.svg';
      }
      if (this.item.vendor === 'Harvest') {
        return 'harvest.png';
      }
      if (this.item.vendor === 'SQLServer') {
        return 'sql.svg';
      }
      if (this.item.vendor === 'Airtable') {
        return 'Airtable_Logo.svg';
      }
      if (this.item.vendor === 'BlackMountain') {
        return 'blkm.png';
      }
      if (this.isDealCloud) {
        return 'DealCloud-logo.png';
      }
      if (this.isDynamo) {
        return 'Dynamo-logo.png';
      }
      if (this.isEfront) {
        return 'efront.png';
      }
      if (this.item.vendor === 'Salesforce') {
        return 'salesforce.svg';
      }
      return 'snowflake.svg';
    },
    isDynamo() {
      return this.item.vendor === 'Dynamo';
    },
    isDealCloud() {
      return this.item.vendor === 'DealCloud';
    },
  },
  methods: {
    onEditClick() {
      this.$emit('on-edit-click', this.item);
    },
    onDeleteClick() {
      this.$emit('on-delete-click', this.item);
    },
    onConnectorClick() {
      this.$router.push({
        name: 'connector',
        params: {
          configurationId: this.item.configurationId,
        },
      });
    },
    getLogoHeight() {
      if (this.isDynamo || this.isDealCloud) return null;

      return 75;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-table {
  //width: 270px;
  border-radius: 0;
  padding: 15px;
  height:180px;
  cursor: pointer;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 5px;
  transition: 0.4s;

  &:hover {
    box-shadow: 0 0 0 2px #19407b;
  }

  .card-title {
    margin-bottom: 0;
  }
}

.header-title {
  font-weight: bold;
  margin-bottom: 0;
}

.actions__wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 5px;
}

.logo__wrapper {
  height: 80px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.connector-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
